import { render } from "./LoadingComp.vue?vue&type=template&id=d0b8faae&scoped=true"
import script from "./LoadingComp.vue?vue&type=script&lang=js"
export * from "./LoadingComp.vue?vue&type=script&lang=js"

import "./LoadingComp.vue?vue&type=style&index=0&id=d0b8faae&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0b8faae"]])

export default __exports__